import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { arrayOf, any } from 'prop-types';
import { connectCurrentRefinements } from 'connectors';
import Criteria from '../Criteria/Criteria';

const CriteriaWrapper = ({ items, ...otherProps }) => (
    <Fragment>
        {items.length > 1 && (
            <div className="filter__title">
                <FormattedMessage
                    id="listing.filters.criteria.title"
                    description="Label of the filters title"
                    defaultMessage="Your filters"
                />
            </div>
        )}
        <Criteria items={items} {...otherProps} />
    </Fragment>
);

CriteriaWrapper.propTypes = {
    items: arrayOf(any).isRequired,
};

export default connectCurrentRefinements(CriteriaWrapper);
